// @flow
import dbg from 'debug';

const debug = dbg('jp:component:native-date-picker');

const areNativeDatePickersSupported = (() => {
  if (__SERVER__) {
    return true;
  }

  try {
    const test = document.createElement('input');
    test.type = 'datetime-local';
    const canHandle = test.type !== 'text';
    debug('areNativeDatePickersSupported', canHandle);
    return canHandle;
  } catch (error) {
    debug('areNativeDatePickersSupported', false);
    return false;
  }
})();

export default areNativeDatePickersSupported;
